import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';
import { getEnv } from '@/lib/env';

const LOCAL_FLAG_OVERRIDES = {
  learningElaAiPptConversionEnable: true,
  learningElaCreateWithAi: true,
};

export const useFlags = () => {
  const flags = useLDFlags();
  return getEnv() === 'local' ? { ...flags, ...LOCAL_FLAG_OVERRIDES } : flags;
};
